<template>
  <div class="instruction">
    <div class="guide-search">
      <div class="guide-search-box center-self flex-wrap">
        <div class="page-title">操作指南</div>
        <div class="input-box">
          <input
            v-model="filterObj.title"
            type="text"
            placeholder="请输入搜索内容"
          >
          <button @click="searchGuide">搜索</button>
        </div>
      </div>
    </div>
    <div class="guide-main flex-wrap">
      <div class="guide-menu">
        <el-menu
          background-color="#ffffff"
          text-color="#333333"
          active-text-color="#999999"
          :default-active="activeId"
        >
          <el-menu-item :index="'1'" @click="selectAll">
            <span slot="title">首页</span>
          </el-menu-item>
          <template v-for="item in menuList">
            <el-submenu
              v-if="item._child && item._child.length"
              :key="item.id"
              :index="item.id"
            >
              <template slot="title">{{ item.directory_name }}</template>
              <!-- 二级菜单 -->
              <template v-for="itemChild in item._child">
                <el-submenu
                  v-if="itemChild._child && itemChild._child.length"
                  :key="itemChild.id"
                  :index="itemChild.id"
                >
                  <template slot="title">{{
                    itemChild.directory_name
                  }}</template>
                  <!-- 三级菜单 -->
                  <el-menu-item
                    v-for="itemChild_Child in itemChild._child"
                    :key="itemChild_Child.id"
                    :index="itemChild_Child.id"
                    @click="selectMenu(itemChild_Child)"
                  >
                    <span slot="title">{{
                      itemChild_Child.directory_name
                    }}</span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item
                  v-else
                  :key="itemChild.id"
                  :index="itemChild.id"
                  @click="selectMenu(itemChild)"
                >
                  <span slot="title">{{ itemChild.directory_name }}</span>
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item
              v-else
              :key="item.id"
              :index="item.id"
              @click="selectMenu(item)"
            >
              <span slot="title">{{ item.directory_name }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="guide-content">
        <GuideList
          v-if="isList"
          :list.sync="itemList"
          :type.sync="type"
          :guide-title.sync="menuTitle"
          :search-content.sync="filterObj.title"
          @guideDetails="guideDetails"
        />
        <GuideContent v-else :guide-content.sync="dataInfo" />
      </div>
    </div>
  </div>
</template>

<script>
import GuideList from '@/components/system/GuideList.vue'
import GuideContent from '@/components/system/GuideContent.vue'
export default {
  name: 'Instruction',
  components: {
    GuideList,
    GuideContent
  },
  data() {
    return {
      menuList: [],
      activeId: '1',
      filterObj: {
        p: 1,
        limit: 9999,
        title: '',
        directory_id: '4',
        is_show: '1'
      },
      itemList: [],
      itemTotal: 0,
      type: 'menu',
      menuTitle: '首页',
      videoObj: {},
      dataInfo: {},
      isList: true
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getChildrenDirectoryList()
    this.getArticleList(this.filterObj)
  },
  methods: {
    async getChildrenDirectoryList() {
      const ret = await this.$http.getChildrenDirectoryList({ id: 4 })
      if (ret.code == 200) {
        this.menuList = ret.data
      }
    },
    async getArticleList(filterObj) {
      const ret = await this.$http.getArticleList(filterObj)
      this.itemList = ret.data.list
      this.itemTotal = ret.data.count - 0
    },
    async getArticleShow(id) {
      const ret = await this.$http.getArticleShow({ id })
      if (ret.code == 200) {
        this.dataInfo = ret.data
        this.isList = false
      }
    },
    selectMenu(item) {
      this.menuTitle = item.directory_name
      this.filterObj.directory_id = item.id
      this.filterObj.title = ''
      this.type = 'menu'
      this.isList = true
      this.getArticleList(this.filterObj)
    },
    selectAll() {
      this.menuTitle = '首页'
      this.filterObj.directory_id = '4'
      this.filterObj.title = ''
      this.type = 'menu'
      this.isList = true
      this.getArticleList(this.filterObj)
    },
    searchGuide() {
      this.filterObj.directory_id = '4'
      this.getArticleList(this.filterObj)
      this.type = 'search'
      this.isList = true
    },
    guideDetails(id) {
      this.getArticleShow(id)
    }
  }
}
</script>
<style lang="scss" scoped>
.instruction {
  .guide-main {
    width: 1200px;
    margin: 0 auto;
    height: 780px;
    ::v-deep .el-menu {
      height: 100%;
      width: 280px;
      border-right: solid 3px #f5f5f5;
    }
    .el-menu-item.is-active {
      background-color: #fff !important;
      color: $color_blue;
    }
    .guide-content {
      flex: 1;
    }
  }
  .guide-search {
    height: 230px;
    background-color: rgba(240, 244, 250, 0.3);
    position: relative;
    .guide-search-box {
      width: 1000px;
      height: 50px;
      justify-content: space-between;
      .page-title {
        color: $color_black;
        font-size: 46px;
        line-height: 50px;
      }
      .input-box {
        input {
          height: 50px;
          box-sizing: border-box;
          border: 1px solid $color_blue;
          width: 600px;
          outline: none;
          border-radius: 5px 0 0 5px;
          text-indent: 20px;
          font-size: 14px;
        }
        button {
          width: 140px;
          height: 50px;
          background-color: $color_blue;
          border-radius: 0 5px 5px 0;
          line-height: 50px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
